export let sundayAbbreviatedLowercase = "_UiMpe";
export default {sundayAbbreviatedLowercase};